import React from 'react';
import $ from 'jquery';
import 'LIBRARY/Components/Reports/StudentWiseLibraryStatistics/StudentWiseLibraryStatistics.css';
import 'LIBRARY/Components/Reports/ResourceListAsPerAccessionNumber/ResourceListAsPerAccessionNumber.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import Pagination from 'react-js-pagination';
import ReactToPrint from 'react-to-print';
import ReactHtmlParser from 'react-html-parser';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import searchPng from "LIBRARY/CommonResources/images/search-stroke.png";
import Select from 'react-select';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';
import axios from "axios";

let userRoleData = [
    {
        label: 'Select Role',
        value: ''
    },
    {
        label: 'Student',
        value: 'student'
    },
    {
        label: 'Teaching',
        value: 'teaching'
    },
    {
        label: 'Non-teaching',
        value: 'nonteaching'
    },
    {
        label: 'External',
        value: 'external'
    }
];

class LibraryEntryReport extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            successModal: false,

            // All resource list as per accession series
            resourceListLoading: false,
            totalResourceListItems: 0,
            resourceList: {},
            sortedIdArray: [],
            pageIndex: 1,
            limit: "10",

            // report filter
            assignedInstituteList: [],
            linkedInstituteArray: [],
            filterInstituteValue: "",
            loadingInstituteData: false,
            filterRole: "",
            filterUserId: "",
            getFilterSectionList: [],
            filterSection: "",
            loadingSectionData: false,
            getFilterDepartmentList: [],
            filterDepartmentValue: "",
            loadingDepartmentData: false,
            filterInDate: '',
            filterInTime: '',
            filterOutDate: '',
            filterOutTime: '',

            //filter button 
            showFilterModal: false,

            // custom list column
            selectAll: true,

            //STATE FOR COLUMN VISIBILITY
            exportItemVisibilityForRows: [
                { name: "Institute", isVisible: true },
                { name: "Name", isVisible: true },
                { name: "User ID", isVisible: true },
                { name: "Employee Code", isVisible: true },
                { name: "Admission No.", isVisible: true },
                { name: "GRN No.", isVisible: true },
                { name: "PRN/University No.", isVisible: true },
                { name: "Role", isVisible: true },
                { name: "Default Academic Branch", isVisible: true },

                { name: "In Time", isVisible: true },
                { name: "Out Time", isVisible: true },
                { name: "Source", isVisible: true },
                { name: "Section", isVisible: true }
            ],

            //STATE FOR header
            exportCSVHeaders: [
                { name: "Institute", key: 'instituteName' },
                { name: "Name", key: 'userName' },
                { name: "User ID", key: 'userTextId' },
                { name: "Employee Code", key: 'employeeId' },
                { name: "Admission No.", key: 'admissionNumber' },
                { name: "GRN No.", key: 'grnNumber' },
                { name: "PRN/University No.", key: 'studentPrnUniversityNo' },
                { name: "Role", key: 'role' },
                { name: "Default Academic Branch", key: 'streamName' },
                { name: "In Time", key: 'inDateTime' },
                { name: "Out Time", key: 'outDateTime' },
                { name: "Source", key: 'source' },
                { name: "Section", key: 'sectionName' },
            ],

            exportItemVisibility: [
                { name: "Institute", isVisible: true },
                { name: "Name", isVisible: true },
                { name: "User ID", isVisible: true },
                { name: "Employee Code", isVisible: true },
                { name: "Admission No.", isVisible: true },
                { name: "GRN No.", isVisible: true },
                { name: "PRN/University No.", isVisible: true },
                { name: "Role", isVisible: true },
                { name: "Default Academic Branch", isVisible: true },

                { name: "In Time", isVisible: true },
                { name: "Out Time", isVisible: true },
                { name: "Source", isVisible: true },
                { name: "Section", isVisible: true },
            ],

            // export all
            isExportAllReportDataFetching: false,
            allReportData: [],
            allSortedIdArray: [],

            //advance filter modal
            advanceFilterModal: false,
        };
    }

    componentDidMount() {
        this.apiCallToGetAssignedInstituteList();
        this.formatCSVExportData('onLoad'); // export data        
    }

    //API CALL METHOD TO LIST OF Institute
    apiCallToGetAssignedInstituteList = async () => {
        this.setState({
            loadingInstituteData: true
        });

        let requestData = {
            'facultyId': config.faculty_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_GetFacultyAssignedInstituteList',
            requestData,
            '/api/library/libraryLinkInstitute.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAssignedInstituteList()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {

                        const instituteArray = [
                            { value: "", label: "Select Institute" }, // static option
                            ...Object.values(apiResult.data).map(item => ({
                                value: item.iid,
                                label: item.institute_name
                            }))
                        ];

                        this.setState({
                            assignedInstituteList: instituteArray,
                            linkedInstituteArray: apiResult?.linkedIidArray,
                            loadingInstituteData: false
                        }, () => {
                            this.GetLibraryEntryListReport();  // report list
                            this.library_getSections();
                            this.getInstituteStreamList()
                        });
                    } else {
                        this.setState({
                            assignedInstituteList: {},
                            linkedInstituteArray: [],
                            loadingInstituteData: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        assignedInstituteList: {},
                        linkedInstituteArray: [],
                        loadingInstituteData: false
                    });
                }
            }
        }
    }

    //API CALL METHOD TO LIST OF Sections
    library_getSections = async () => {
        this.setState({
            loadingSectionData: true
        });

        let requestData = {
            "instituteId": config.institute_id,
            'iidArray': this.state.linkedInstituteArray,
            "remainingCapacity": ""
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_getSections',
            requestData,
            '/api/library/library.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.library_getSections()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        const sectionArray = Object.values(apiResult.data).map(item => ({
                            value: item.UniqueId,
                            label: item.instituteName
                                ? `${item.sectionTitle} | ${item.instituteName}`
                                : item.sectionTitle
                        }));

                        this.setState({
                            getFilterSectionList: sectionArray,
                            loadingSectionData: false
                        });
                    } else {
                        this.setState({
                            getFilterSectionList: {},
                            loadingSectionData: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        getFilterSectionList: {},
                        loadingSectionData: false
                    });
                }
            }
        }
    }

    //API CALL METHOD TO LIST OF Department
    getInstituteStreamList = async () => {
        this.setState({
            loadingDepartmentData: true
        });

        let formData = new FormData();
        formData.append("getInstituteStreamList", true);
        formData.append("iid", config.institute_id);

        axios({
            method: "post",
            url: config.RootUrl + "/api/generic_api.php",
            data: formData,
            headers: {
                Accept: "application/json",
                "Content-Type": "multipart/form-data",
            },
        }).then((response) => {
            let jsonResponse = response.data;

            const departmentArray = Object.values(jsonResponse.streamData).map(item => ({
                value: item.sid,
                label: item.name
            }));

            this.setState({
                getFilterDepartmentList: departmentArray,
                loadingDepartmentData: false
            });

        }).catch(error => {
            console.log(error);
        });
    }

    //API CALL METHOD TO LIST OF REPORT
    GetLibraryEntryListReport = async () => {
        this.setState({
            resourceListLoading: true
        });

        let requestData = {
            'iidArray': this.state.linkedInstituteArray,
            "instituteId": config.institute_id,
            "filterIID": this.state.filterInstituteValue ? this.state.filterInstituteValue?.value : "",
            'pageIndex': this.state.pageIndex,
            'limit': this.state.limit,
            "sId": this.state.filterDepartmentValue ? this.state.filterDepartmentValue?.value : "",
            "userId": this.state.filterUserId,
            "userRole": this.state.filterRole ? this.state.filterRole?.value : "",
            "inDate": this.state.filterInDate,
            "inTime": this.state.filterInTime,
            "outDate": this.state.filterOutDate,
            "outTime": this.state.filterOutTime,
            "sectionId": this.state.filterSection ? this.state.filterSection?.value : "",
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'library_getEntries',
            requestData,
            '/api/library/library.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryEntryListReport()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {


                        this.setState({
                            resourceList: apiResult.data,
                            totalResourceListItems: apiResult?.Total,
                            sortedIdArray: apiResult?.sortedIdArray,
                            resourceListLoading: false
                        });
                    } else {
                        this.setState({
                            resourceList: {},
                            sortedIdArray: [],
                            totalResourceListItems: 0,
                            resourceListLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        resourceList: {},
                        totalResourceListItems: 0,
                        resourceListLoading: false
                    });
                }
            }
        }
    }

    // filter user id on change
    handleUserIdChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", filterUserId: event.target.value });
    };
    handleUserIdKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.GetLibraryEntryListReport();
        }
    };

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        if (this.state.filterInstituteValue !== '' || this.state.filterRole !== '' || this.state.filterUserId !== '' || this.state.filterSection !== "" || this.state.filterDepartmentValue !== "" || this.state.filterInDate !== "" || this.state.filterInTime !== "" || this.state.filterOutDate !== "" || this.state.filterOutTime !== "") {
            this.setState({
                pageIndex: 1, limit: event.target.value, filterInstituteValue: this.state.filterInstituteValue, filterRole: this.state.filterRole, filterUserId: this.state.filterUserId, filterSection: this.state.filterSection, filterDepartmentValue: this.state.filterDepartmentValue, filterInDate: this.state.filterInDate, filterInTime: this.state.filterInTime, filterOutDate: this.state.filterOutDate, filterOutTime: this.state.filterOutTime,
            }, () => {
                this.GetLibraryEntryListReport();
            });
        } else {
            this.setState({ pageIndex: 1, limit: event.target.value }, () => {
                this.GetLibraryEntryListReport();
            });
        }
    }

    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        if (this.state.filterInstituteValue !== '' || this.state.filterRole !== '' || this.state.filterUserId !== '' || this.state.filterSection !== "" || this.state.filterDepartmentValue !== "" || this.state.filterInDate !== "" || this.state.filterInTime !== "" || this.state.filterOutDate !== "" || this.state.filterOutTime !== "") {
            this.setState({ pageIndex: pageNumber, filterInstituteValue: this.state.filterInstituteValue, filterRole: this.state.filterRole, filterUserId: this.state.filterUserId, filterSection: this.state.filterSection, filterDepartmentValue: this.state.filterDepartmentValue, filterInDate: this.state.filterInDate, filterInTime: this.state.filterInTime, filterOutDate: this.state.filterOutDate, filterOutTime: this.state.filterOutTime, }, () => {
                this.GetLibraryEntryListReport();
            });
        } else {
            this.setState({ pageIndex: pageNumber }, () => {
                this.GetLibraryEntryListReport();
            });
        }
    };

    // CLEAR ALL FILTER
    handleClearAllReportFilter = () => {
        this.setState({
            filterInstituteValue: "", filterRole: "", filterUserId: "", filterSection: "", filterDepartmentValue: "", filterInDate: "", filterInTime: "", filterOutDate: "", filterOutTime: "", limit: "10", pageIndex: 1
        }
            , () => {
                this.GetLibraryEntryListReport();
            }
        )
    };

    // column visibility on change
    updateColumnDisplay = (columnIndex) => {
        let exportItemVisibilityForRows = this.state.exportItemVisibilityForRows;

        exportItemVisibilityForRows[columnIndex].isVisible = !exportItemVisibilityForRows[columnIndex].isVisible;

        this.setState({
            exportItemVisibilityForRows
        });
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
    }

    exportAllReportCSV = () => {
        document.getElementById('exportAll').click();
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportSelectedCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr. No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            this.state.exportItemVisibility.map(columnInfo => {
                if (csvInfo.label == columnInfo.name) {
                    if (columnInfo.isVisible) {
                        exportSelectedCSVHeaders.push(csvInfo);
                    }
                }
            });
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    // export all functionality
    returnExportAllData = () => {
        // display applied filters while exporting data
        let FilterArray = [];
        let filterInstituteName = this.state.filterInstituteValue
        let filterUserRole = this.state.filterRole
        let filterUserId = this.state.filterUserId
        let filterSection = this.state.filterSection
        let filterDepartment = this.state.filterDepartmentValue
        let filterInDate = this.state.filterInDate
        let filterInTime = this.state.filterInTime
        let filterOutDate = this.state.filterOutDate
        let filterOutTime = this.state.filterOutTime

        if (filterInstituteName) {
            FilterArray.push(`Institute Name- ${filterInstituteName?.label}`)
        }

        if (filterUserRole) {
            FilterArray.push(`User Role - ${filterUserRole?.label}`)
        }

        if (filterUserId) {
            FilterArray.push(`User Id - ${filterUserId}`)
        }

        if (filterSection) {
            FilterArray.push(`Section Name - ${filterSection?.label}`)
        }

        if (filterDepartment) {
            FilterArray.push(`Department Name - ${filterDepartment?.label}`)
        }

        if (filterInDate) {
            FilterArray.push(`In Date - ${filterInDate}`)
        }

        if (filterInTime) {
            FilterArray.push(`In Time - ${filterInTime}`)
        }

        if (filterOutDate) {
            FilterArray.push(`Out Date - ${filterOutDate}`)
        }

        if (filterOutTime) {
            FilterArray.push(`Out Time - ${filterOutTime}`)
        }

        return (
            <table className="table table-bordered" id="ExportAllResourceTitleReport" style={{ marginTop: '15px', display: 'none' }}>
                <thead>
                    <tr>
                        <tr className='d-none'>
                            <th colSpan="12" style={{ textAlign: 'center' }}>
                                {config.institute_name}
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="12" style={{ textAlign: 'center' }}>
                                Library Entry
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="12" ></th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="12" style={{ textAlign: 'center' }}>
                                {
                                    FilterArray.join(" | ")
                                }
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="12" ></th>
                        </tr>
                        <th>Sr. No</th>
                        {this.state.exportItemVisibilityForRows[0].isVisible && <th>Institute</th>}
                        {this.state.exportItemVisibilityForRows[1].isVisible && <th>Name</th>}
                        {this.state.exportItemVisibilityForRows[2].isVisible && <th>User ID</th>}
                        {this.state.exportItemVisibilityForRows[3].isVisible && <th>Employee Code</th>}
                        {this.state.exportItemVisibilityForRows[4].isVisible && <th>Admission No.</th>}
                        {this.state.exportItemVisibilityForRows[5].isVisible && <th>GRN No.</th>}
                        {this.state.exportItemVisibilityForRows[6].isVisible && <th>PRN/University No.</th>}
                        {this.state.exportItemVisibilityForRows[7].isVisible && <th>Role</th>}
                        {this.state.exportItemVisibilityForRows[8].isVisible && <th>Default Academic Branch</th>}
                        {this.state.exportItemVisibilityForRows[9].isVisible && <th>In Time</th>}
                        {this.state.exportItemVisibilityForRows[10].isVisible && <th>Out Time</th>}
                        {this.state.exportItemVisibilityForRows[11].isVisible && <th>Source</th>}
                        {this.state.exportItemVisibilityForRows[12].isVisible && <th>Section</th>}
                    </tr>
                </thead>

                <tbody>
                    {
                        this.state.isExportAllReportDataFetching ?
                            <tr>
                                <td colSpan="12">
                                    <ButtonLoader />
                                </td>
                            </tr>
                            :
                            Object.keys(this.state.allReportData).length > 0 ?
                                (Object.values(this.state.allReportData).map((resource, index) => {
                                    return (

                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {this.state.exportItemVisibilityForRows[0].isVisible && <td>{resource?.instituteName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[1].isVisible && <td>{resource?.userName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[2].isVisible && <td>{resource?.userTextId || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[3].isVisible && <td>{resource?.employeeId || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[4].isVisible && <td>{resource?.admissionNumber || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[5].isVisible && <td>{resource?.grnNumber || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[6].isVisible && <td>{resource?.studentPrnUniversityNo || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[7].isVisible && <td>{resource?.userRole == "student" ? "Student" : resource?.userRole == "teaching" ? "Teaching" : resource?.userRole == "external" ? "External" : "Non-teaching"}</td>}
                                            {this.state.exportItemVisibilityForRows[8].isVisible && <td>{resource?.streamName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[9].isVisible && <td>{resource?.inDateTime || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[10].isVisible && <td>{resource?.outDateTime || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[11].isVisible && <td>{(resource?.out_time_updated_by || "").charAt(0).toUpperCase() + (resource?.out_time_updated_by || "").slice(1)}</td>}
                                            {this.state.exportItemVisibilityForRows[12].isVisible && <td>{resource?.sectionTitle + "|" + resource?.sectionInstituteName || ""}</td>}
                                        </tr>
                                    )
                                })) :
                                <tr>
                                    <td colSpan="12">
                                        No data found.
                                    </td>
                                </tr>
                    }
                </tbody>
            </table>
        );
    };

    // METHOD TO GET EXPORT REPORT DATA RECURSIVELY
    methodToExportReportData = async (pageIndex) => {
        const { totalResourceListItems } = this.state;
        const totalPages = Math.ceil(totalResourceListItems / 50);

        pageIndex++; // Increment page index to fetch the next set of data

        if (pageIndex <= totalPages) {
            this.setState({
                isExportAllReportDataFetching: true
            });

            let jsonResponse;

            let requestData = {
                'iidArray': this.state.linkedInstituteArray,
                "instituteId": config.institute_id,
                "filterIID": this.state.filterInstituteValue ? this.state.filterInstituteValue?.value : "",
                'pageIndex': pageIndex,
                'limit': 50,
                "sId": this.state.filterDepartmentValue ? this.state.filterDepartmentValue?.value : "",
                "userId": this.state.filterUserId,
                "userRole": this.state.filterRole ? this.state.filterRole?.value : "",
                "inDate": this.state.filterInDate,
                "inTime": this.state.filterInTime,
                "outDate": this.state.filterOutDate,
                "outTime": this.state.filterOutTime,
                "sectionId": this.state.filterSection ? this.state.filterSection?.value : "",
            };

            jsonResponse = await LibraryApiCall.makeApiCall(
                'library_getEntries',
                requestData,
                '/api/library/library.php'
            )


            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.methodToExportReportData(pageIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult.data;
                    let Data = [];
                    let sortedResponseArrayFromApi = jsonResponse.APIResult.sortedIdArray || [];

                    sortedResponseArrayFromApi.map((uid) => {
                        Data.push(apiResult[uid]);
                    });

                    // Concatenate new data and update state
                    this.setState((prevState) => ({
                        allReportData: [
                            ...prevState.allReportData,
                            ...Data,
                        ],
                    }), () => {
                        // Fetch the next page recursively
                        this.methodToExportReportData(pageIndex);
                    });

                } else {
                    this.setState({
                        isExportAllReportDataFetching: false,
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while getting library entry data. Please try again later.'
                    });
                }
            }
        } else {
            // Final step when all pages are fetched
            this.setState({
                isExportAllReportDataFetching: false,
            }, () => {
                // Trigger any further actions after fetching all data
                setTimeout(() => {
                    this.exportAllReportCSV();
                }, 500);
            });
        }
    };

    // METHOD TO ADVANCE FILTER
    returnAdvanceFilterModelData = () => {
        return (
            <div style={{ display: this.state.advanceFilterModal ? 'flex' : 'none' }} id="reportsSideMenu">
                <div id="reportDataContainer">
                    {/* Modal Header */}
                    <div className="modal-header" style={{ padding: '20px 25px', borderBottom: '2px solid #e0e0e0' }}>
                        <h6 className="modal-title">
                            <FontAwesomeIcon size='sm' icon={["fa", "filter"]} style={{ marginRight: '10px' }} />
                            Advanced Filter
                        </h6>
                        <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => { this.setState({ advanceFilterModal: false }) }} style={{ cursor: "pointer" }} />
                    </div>

                    {/* Modal Content */}
                    <div className='col-md-12 pt-2 pb-3'>
                        {/* Form Group: department*/}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Department</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        options={this.state.getFilterDepartmentList}
                                        value={this.state.filterDepartmentValue}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                filterDepartmentValue: event || "",
                                            });
                                        }}
                                        placeholder="Select Department"
                                        isLoading={this.state.loadingDepartmentData}
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42,
                                                height: 'auto',
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999,
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingDepartmentData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                        </div>


                        {/* Form Group: in date time and out date time*/}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>In Date</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input type="date" className="form-control formControlAutoTask" value={this.state.filterInDate} onChange={(e) => { this.setState({ filterInDate: e.target.value }) }} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>In Time</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input type="time" className="form-control formControlAutoTask" value={this.state.filterInTime} onChange={(e) => { this.setState({ filterInTime: e.target.value }) }} />
                                </div>
                            </div>
                        </div>

                        {/* Form Group: in date time and out date time*/}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Out Date</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input type="date" className="form-control formControlAutoTask" value={this.state.filterOutDate} onChange={(e) => { this.setState({ filterOutDate: e.target.value }) }} />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Out Time</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <input type="time" className="form-control formControlAutoTask" value={this.state.filterOutTime} onChange={(e) => { this.setState({ filterOutTime: e.target.value }) }} />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="modal-footer" style={{ padding: '20px 25px' }}>
                        <button
                            className="btn custom-btn"
                            style={{ fontSize: '14px', borderRadius: '7px' }}
                            onClick={() => {

                                this.setState({
                                    filterInstituteValue: "", filterRole: "", filterUserId: "", filterSection: "", filterDepartmentValue: "", filterInDate: "", filterInTime: "", filterOutDate: "", filterOutTime: "", limit: "10", pageIndex: 1
                                }
                                    , () => {
                                        this.GetLibraryEntryListReport();
                                    }
                                )
                            }}
                        >
                            Clear
                        </button>
                        <button className="btn btn-primary" style={{ fontSize: '14px', borderRadius: '7px' }} onClick={() => {
                            this.setState({ advanceFilterModal: false }, () => {
                                this.GetLibraryEntryListReport();
                            })
                        }}>
                            Apply
                        </button>
                    </div>
                    {/* </div> */}
                </div>
            </div >
        );
    }

    render() {
        // display applied filters while exporting data
        let FilterArray = [];
        let filterInstituteName = this.state.filterInstituteValue
        let filterUserRole = this.state.filterRole
        let filterUserId = this.state.filterUserId
        let filterSection = this.state.filterSection
        let filterDepartment = this.state.filterDepartmentValue
        let filterInDate = this.state.filterInDate
        let filterInTime = this.state.filterInTime
        let filterOutDate = this.state.filterOutDate
        let filterOutTime = this.state.filterOutTime

        if (filterInstituteName) {
            FilterArray.push(`Institute Name- ${filterInstituteName?.label}`)
        }

        if (filterUserRole) {
            FilterArray.push(`User Role - ${filterUserRole?.label}`)
        }

        if (filterUserId) {
            FilterArray.push(`User Id - ${filterUserId}`)
        }

        if (filterSection) {
            FilterArray.push(`Section Name - ${filterSection?.label}`)
        }

        if (filterDepartment) {
            FilterArray.push(`Department Name - ${filterDepartment?.label}`)
        }

        if (filterInDate) {
            FilterArray.push(`In Date - ${filterInDate}`)
        }

        if (filterInTime) {
            FilterArray.push(`In Time - ${filterInTime}`)
        }

        if (filterOutDate) {
            FilterArray.push(`Out Date - ${filterOutDate}`)
        }

        if (filterOutTime) {
            FilterArray.push(`Out Time - ${filterOutTime}`)
        }

        return (
            <div>
                <div className="pl-3 pr-3" style={{ height: '100%' }}>
                    <div style={{ height: '100%' }}></div>
                    <div className="studentStatisticalReport">
                        <div>
                            {/* header */}
                            <div className="card" style={{ marginTop: '20px', boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF', padding: '8px' }}>
                                <div className="d-flex col-md-12 px-0">
                                    <div className="col-md-10 d-flex justify-content-start align-items-center p-0">
                                        {/* action button - filter */}
                                        <div className="d-flex">
                                            <div>
                                                {/* filter data form*/}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                                        {/* Based On Institute */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Institute Name</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <Select
                                                                    options={this.state.assignedInstituteList}
                                                                    value={this.state.filterInstituteValue}
                                                                    className="basic-multi-select-filter"
                                                                    onChange={(event) => {
                                                                        this.setState({
                                                                            filterInstituteValue: event || "", pageIndex: 1, limit: "10",
                                                                        }, () => this.GetLibraryEntryListReport());
                                                                    }}
                                                                    placeholder="Select Institute Name"
                                                                    isLoading={this.state.loadingInstituteData}
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            width: '100%',
                                                                            minHeight: 42,
                                                                            height: 'auto',
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999
                                                                        }),
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        }),
                                                                        placeholder: (base) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                        }),
                                                                        option: (base, state) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                            color: state.isSelected ? '#333' : '#555',
                                                                        }),
                                                                    }}
                                                                    menuPortalTarget={document.body}
                                                                    noOptionsMessage={() => (this.state.loadingInstituteData ? "Loading..." : "No options found")}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based On Role */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>User Role</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <Select
                                                                    options={userRoleData}
                                                                    value={this.state.filterRole}
                                                                    className="basic-multi-select-filter"
                                                                    onChange={(event) => {
                                                                        this.setState({
                                                                            filterRole: event || [],  pageIndex: 1, limit: "10",
                                                                        }, () => this.GetLibraryEntryListReport());
                                                                    }}
                                                                    placeholder="Select User Role"
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            width: '100%',
                                                                            minHeight: 42,
                                                                            height: 'auto',
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999
                                                                        }),
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        }),
                                                                        placeholder: (base) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                        }),
                                                                        option: (base, state) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                            color: state.isSelected ? '#333' : '#555',
                                                                        }),
                                                                    }}
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based On Search by user ID */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>User ID</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <img
                                                                    src={searchPng}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        left: '10px',
                                                                        top: '50%',
                                                                        transform: 'translateY(-50%)',
                                                                        color: '#ccc',
                                                                        backgroundColor: 'white',
                                                                        width: '15px',
                                                                        height: '15px',
                                                                        zIndex: 1,
                                                                    }}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="form-control formControlAutoTask"
                                                                    id="searchByUserIdFilter"
                                                                    placeholder="Search by User ID"
                                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px', fontSize: "13px" }}
                                                                    value={this.state.filterUserId} // Bind value to state
                                                                    onChange={this.handleUserIdChange} // Handle input changes
                                                                    onKeyPress={this.handleUserIdKeyPress} // Trigger API call on Enter
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based On Section */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Section</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <Select
                                                                    options={this.state.getFilterSectionList}
                                                                    value={this.state.filterSection}
                                                                    className="basic-multi-select-filter"
                                                                    onChange={(event) => {
                                                                        this.setState({
                                                                            filterSection: event || [],  pageIndex: 1, limit: "10",
                                                                        }, () => this.GetLibraryEntryListReport());
                                                                    }}
                                                                    placeholder="Select Section"
                                                                    isLoading={this.state.loadingSectionData}
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            width: '100%',
                                                                            minHeight: 42,
                                                                            height: 'auto',
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999
                                                                        }),
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999,
                                                                        }),
                                                                        placeholder: (base) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                        }),
                                                                        option: (base, state) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                            color: state.isSelected ? '#333' : '#555',
                                                                        }),
                                                                    }}
                                                                    menuPortalTarget={document.body}
                                                                    noOptionsMessage={() => (this.state.loadingSectionData ? "Loading..." : "No options found")}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p style={{ marginLeft: "20px", color: '#7A7A7A', fontSize: '12px' }}>Press "Enter" to get library entry filter result.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-2 d-flex justify-content-end align-items-center p-0">
                                        <div className="d-flex ml-2" title="Advance Filter">
                                            <button className="btn outline-button" style={{ borderRadius: '5px', boxShadow: 'none' }} onClick={() => {
                                                this.setState({
                                                    advanceFilterModal: true,
                                                })
                                            }}> <style type="text/css" media="print">
                                                    {"@page { size: auto; }"}
                                                </style>
                                                <FontAwesomeIcon size='lg' icon={faSlidersH} style={{ cursor: "pointer", color: '#0465AC' }} />
                                            </button>
                                        </div>

                                        {Object.keys(this.state.resourceList).length == 0 ? null :
                                            <>
                                                <div className="d-flex">
                                                    {this.state.isExportAllReportDataFetching && <div><ButtonLoader /></div>}
                                                </div>

                                                {/* 1 action button - export data */}
                                                <div className="d-flex ml-2" title="Click to Export" >
                                                    <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                        {"@page { size: auto; }"}
                                                    </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                                    {/* 2.1 action button option - export and export all */}
                                                    <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                        <span>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="export"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="resourceTitleReport"
                                                                    filename="LibraryEntryReport"
                                                                    sheet="tablexls"
                                                                    buttonText="Export to Excel "
                                                                >
                                                                </ReactHTMLTableToExcel>
                                                            </div>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="exportAll"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="ExportAllResourceTitleReport"   // export all functionality
                                                                    filename="ExportAllLibraryEntryReport"
                                                                    sheet="tablexls"
                                                                    buttonText="Export All to Excel"
                                                                />
                                                            </div>
                                                            <button
                                                                onClick={this.formatCSVExportData}
                                                                className="dropdown-item"
                                                                title="Click to Export"
                                                                style={{ boxShadow: 'none' }}
                                                            >
                                                                Export
                                                            </button>
                                                            {this.state.isExportAllReportDataFetching ? (
                                                                <p className="dropdown-item">
                                                                    Exporting report . . .&nbsp;
                                                                    <FontAwesomeIcon
                                                                        icon={["fas", "circle-notch"]}
                                                                        className="rotate"
                                                                    />
                                                                </p>
                                                            ) : (
                                                                <button
                                                                    onClick={() => this.setState({ allReportData: [] }, () => {
                                                                        this.methodToExportReportData(0)
                                                                    })}
                                                                    className="dropdown-item"
                                                                    title="Click to Export All"
                                                                    style={{ boxShadow: 'none' }}
                                                                >
                                                                    Export All
                                                                </button>
                                                            )}
                                                        </span>

                                                    </div>

                                                </div>

                                                {/* 2 action button - print */}
                                                <div className="d-flex ml-2" title="Click to Print">
                                                    <span className="print-button">
                                                        <ReactToPrint
                                                            trigger={() => {
                                                                return (
                                                                    <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                        <style type="text/css" media="print">
                                                                            {"@page { size: auto; }"}
                                                                        </style>
                                                                        <span>
                                                                            <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                        </span>
                                                                    </div>
                                                                )
                                                            }}
                                                            content={() => this.componentRef}
                                                        />
                                                    </span>
                                                </div>

                                                {/* 3 action button - column visibility */}
                                                <div className="d-flex ml-2" title="Click to Customize Columns">
                                                    {/* <button className="print-button btn outline-button" style={{ borderRadius: '2.77px' }}> <style type="text/css" media="print">
                                        {"@page { size: auto; }"}
                                    </style> */}
                                                    <FontAwesomeIcon size='lg' id='settingsDropdownMenu' aria-expanded="false" data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" title="Click to Customize Columns" style={{ cursor: 'pointer', marginLeft: "8px", color: '#0465AC' }} color="#000" icon={['fas', 'cog']} />
                                                    {/* </button> */}

                                                    {/* action modal - column visibility*/}
                                                    <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='settingsDropdownMenu'>
                                                        <div id='settingDropdown' className='settingDropdown-body'>
                                                            {
                                                                this.state.exportItemVisibilityForRows.map((columnInfo, index) => {
                                                                    return (
                                                                        <p className="dropdown-item" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }} key={columnInfo.name} onClick={() => this.updateColumnDisplay(index)}>
                                                                            <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                                            <input type="checkbox" checked={columnInfo.isVisible} />
                                                                        </p>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                (this.state.filterInstituteValue !== "" || this.state.filterRole !== '' || this.state.filterUserId !== '' || this.state.filterSection !== '' || this.state.filterDepartmentValue !== '' || this.state.filterInDate !== '' || this.state.filterInTime !== '' || this.state.filterOutDate !== '' || this.state.filterOutTime !== '') &&
                                <div className='filter-apply'>
                                    <p className='vm_custom_body5'>Filters are applied.</p>
                                    <p className="clear-all vm_custom_body5" onClick={this.handleClearAllReportFilter}>Clear All</p>
                                </div>
                            }
                        </div>

                        {/* list table */}
                        <div className="col-md-12 px-0 div_table">
                            <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                                <div className="print-area" ref={el => this.componentRef = el}>
                                    <div className="buildingReport_logo">
                                        <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                        <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                        <h3>Library Entry</h3>
                                        {
                                            FilterArray.join(" | ")
                                        }
                                    </div>
                                    <table className="table table-bordered  vm_libraryReport_table" id="resourceTitleReport">
                                        <thead>
                                            <tr>
                                                <tr className='d-none'>
                                                    <th colSpan="12" style={{ textAlign: 'center' }}>
                                                        {config.institute_name}
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="12" style={{ textAlign: 'center' }}>
                                                        Library Entry
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="12" ></th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="12" style={{ textAlign: 'center' }}>
                                                        {
                                                            FilterArray.join(" | ")
                                                        }
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="12" ></th>
                                                </tr>
                                                <th>Sr. No</th>
                                                {this.state.exportItemVisibilityForRows[0].isVisible && <th>Institute</th>}
                                                {this.state.exportItemVisibilityForRows[1].isVisible && <th>Name</th>}
                                                {this.state.exportItemVisibilityForRows[7].isVisible && <th>Role</th>}
                                                {this.state.exportItemVisibilityForRows[2].isVisible && <th>User ID</th>}
                                                {this.state.exportItemVisibilityForRows[3].isVisible && <th>Employee Code</th>}
                                                {this.state.exportItemVisibilityForRows[4].isVisible && <th>Admission No.</th>}
                                                {this.state.exportItemVisibilityForRows[5].isVisible && <th>GRN No.</th>}
                                                {this.state.exportItemVisibilityForRows[6].isVisible && <th>PRN/University No.</th>}
                                                {this.state.exportItemVisibilityForRows[8].isVisible && <th>Default Academic Branch</th>}
                                                {this.state.exportItemVisibilityForRows[9].isVisible && <th>In Time</th>}
                                                {this.state.exportItemVisibilityForRows[10].isVisible && <th>Out Time</th>}
                                                {this.state.exportItemVisibilityForRows[11].isVisible && <th>Source</th>}
                                                {this.state.exportItemVisibilityForRows[12].isVisible && <th>Section</th>}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                this.state.resourceListLoading ? (
                                                    <tr>
                                                        <td colSpan="12">
                                                            <ButtonLoader />
                                                        </td>
                                                    </tr>
                                                ) : this.state.sortedIdArray &&
                                                    this.state.sortedIdArray.length > 0 ? (

                                                    this.state.sortedIdArray.map((id, index) => {

                                                        const resource = this.state.resourceList[id];
                                                        if (!resource) return null;

                                                        return (
                                                            <tr key={id}>
                                                                <td>
                                                                    {this.state.limit === 'all'
                                                                        ? index + 1
                                                                        : ((this.state.pageIndex - 1) * this.state.limit) + index + 1}
                                                                </td>

                                                                {this.state.exportItemVisibilityForRows[0].isVisible && (
                                                                    <td>{resource?.instituteName || ""}</td>
                                                                )}
                                                                {this.state.exportItemVisibilityForRows[1].isVisible && (
                                                                    <td>{resource?.userName || ""}</td>
                                                                )}
                                                                {this.state.exportItemVisibilityForRows[7].isVisible && (
                                                                    <td>
                                                                        {resource?.userRole === "student"
                                                                            ? "Student"
                                                                            : resource?.userRole === "teaching"
                                                                                ? "Teaching"
                                                                                : resource?.userRole === "external"
                                                                                    ? "External"
                                                                                    : "Non-teaching"}
                                                                    </td>
                                                                )}
                                                                {this.state.exportItemVisibilityForRows[2].isVisible && (
                                                                    <td>{resource?.userTextId || ""}</td>
                                                                )}
                                                                {this.state.exportItemVisibilityForRows[3].isVisible && (
                                                                    <td>{resource?.employeeId || ""}</td>
                                                                )}
                                                                {this.state.exportItemVisibilityForRows[4].isVisible && (
                                                                    <td>{resource?.admissionNumber || ""}</td>
                                                                )}
                                                                {this.state.exportItemVisibilityForRows[5].isVisible && (
                                                                    <td>{resource?.grnNumber || ""}</td>
                                                                )}
                                                                {this.state.exportItemVisibilityForRows[6].isVisible && (
                                                                    <td>{resource?.studentPrnUniversityNo || ""}</td>
                                                                )}
                                                                {this.state.exportItemVisibilityForRows[8].isVisible && (
                                                                    <td>{resource?.streamName || ""}</td>
                                                                )}
                                                                {this.state.exportItemVisibilityForRows[9].isVisible && (
                                                                    <td>{resource?.inDateTime || ""}</td>
                                                                )}
                                                                {this.state.exportItemVisibilityForRows[10].isVisible && (
                                                                    <td>{resource?.outDateTime || ""}</td>
                                                                )}
                                                                {this.state.exportItemVisibilityForRows[11].isVisible && (
                                                                    <td>
                                                                        {(resource?.out_time_updated_by || "").charAt(0).toUpperCase() + (resource?.out_time_updated_by || "").slice(1)}
                                                                    </td>
                                                                )}
                                                                {this.state.exportItemVisibilityForRows[12].isVisible && (
                                                                    <td>
                                                                        {(resource?.sectionTitle && resource?.sectionInstituteName)
                                                                            ? `${resource.sectionTitle} | ${resource.sectionInstituteName}`
                                                                            : resource?.sectionTitle || resource?.sectionInstituteName || ""}
                                                                    </td>
                                                                )}
                                                            </tr>
                                                        );
                                                    })

                                                ) : (
                                                    <tr>
                                                        <td colSpan="12">
                                                            No data found.
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* table footer pagination */}
                            {
                                (Object.keys(this.state.resourceList).length > 0 || Object.keys(this.state.resourceList).length > this.state.limit) &&
                                <div className='row px-0'>
                                    <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                        <div className='row align-items-center justify-content-between'>
                                            <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                                <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                    <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                        <select className="mx-2 p-1 vm_select_border" name="pageSize" id=""
                                                            value={this.state.limit}
                                                            onChange={this.changeShowEntriesControl}
                                                        >
                                                            <option value={10}>Entries Per Page 10</option>
                                                            <option value={25}>Entries Per Page 25</option>
                                                            <option value={40}>Entries Per Page 40</option>
                                                            <option value={100}>Entries Per Page 100</option>
                                                            <option value={250}>Entries Per Page 250</option>
                                                        </select>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                                <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                    <Pagination
                                                        activePage={this.state.pageIndex}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.totalResourceListItems}
                                                        pageRangeDisplayed={3}
                                                        onChange={this.updatePaginationCount}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                this.returnExportAllData()
                                            }
                                            <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                                <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                    Total Records : {this.state.totalResourceListItems || 0}
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        {
                            this.returnAdvanceFilterModelData()
                        }
                    </div >
                </div>
            </div >

        );
    }
}


export default LibraryEntryReport;